module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vanguard-payment-form"
  }, [(_vm.displayPaymentForm && _vm.testLevel === _vm.constants.TEST_LEVEL_VANGUARD) ? _c('div', {
    staticClass: "vanguard-payment-form-test-submit-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.validateOrder.apply(null, arguments)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('all.testSubmitPayment')) + " - " + _vm._s(_vm.$t('all.' + _vm.paymentMethod)) + "\n  ")]) : (_vm.displayPaymentForm && _vm.testLevel !== _vm.constants.TEST_LEVEL_VANGUARD) ? _c('div', {
    staticClass: "vanguard-payment-iframe-container"
  }, [(_vm.hasPaymentError) ? _c('div', {
    staticClass: "vanguard-payment-error-message alert alert-warning"
  }, [_vm._v("\n      " + _vm._s(_vm.$t("all.paymentErrorMessage")) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isPaymentFormLoading) ? _c('div', {
    staticClass: "vanguard-spinner-container"
  }, [_c('div', {
    staticClass: "spinner-border",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t("all.loading")))])])]) : _vm._e(), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPaymentFormLoading),
      expression: "!isPaymentFormLoading"
    }],
    ref: "paymentIFrame",
    staticClass: "vanguard-payment-iframe",
    style: (("height: " + (_vm.paymentMethod === _vm.constants.PAYMENT_METHOD_SEPA ? _vm.iframeHeightPalyance : _vm.iframeHeightOgone) + "px")),
    attrs: {
      "src": _vm.iframeUrl,
      "allowtransparency": "true"
    },
    on: {
      "load": _vm.initPaymentIFrame
    }
  })]) : (!_vm.displayPaymentForm) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [(_vm.isAppMultiple) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.$t('form.fillFormMultiple')) + "\n          ")]) : (_vm.currentChoiceIsAllowed) ? _c('span', [_vm._v("\n              " + _vm._s(_vm.$t('form.fillForm')) + "\n          ")]) : (!_vm.currentChoiceIsAllowed) ? _c('span', [_vm._v("\n              " + _vm._s(_vm.$t('form.alreadyPurchased')) + "\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayBankCheckInstructions) ? _c('div', [_c('div', {
    staticClass: "module-block module-block-cheque",
    domProps: {
      "innerHTML": _vm._s(_vm.getBankCheckInstructions)
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e63e3fe","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/payment-form.vue
// module id = 857
// module chunks = 0 1